export { default as EncounterTags } from './EncounterTags';
